import type { TourDocumentStatus } from 'shared/api/tours/document-data'

const contractStatuses = new Set<string>([
  'DOCUMENT_TO_SIGNING',
  'DOCUMENT_SIGNED_TO_PAY',
  'TOUR_TO_ADDITIONAL',
] satisfies TourDocumentStatus[])

export const isContractStatus = (status: string): boolean =>
  contractStatuses.has(status)
